import { render } from "./EnvioSms.vue?vue&type=template&id=52eb9459&scoped=true"
import script from "./EnvioSms.vue?vue&type=script&lang=js"
export * from "./EnvioSms.vue?vue&type=script&lang=js"

import "./EnvioSms.vue?vue&type=style&index=0&id=52eb9459&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52eb9459"]])

export default __exports__